// extracted by mini-css-extract-plugin
export default {"root":"EAsB6j","rounded":"___0RJ","fullWidth":"pMkHN2","mobile":"ZjXyK0","loading":"tjP5fy","primary":"HsSQ3e","secondary":"dkBwgz"};